import {createRouter, createWebHistory, RouteLocationNormalized, RouteRecordRaw} from 'vue-router'
import Menu from "../components/Menu.vue";
import authRoutes from "@/router/auth";
import NotFound from "@/views/NotFound.vue";
import Login from "@/views/Login.vue";
import projectRoutes from "@/router/project";
import PermissionDenied from "@/views/PermissionDenied.vue";
import crmRoutes from "@/router/crm";
import Home from "@/views/Home.vue";
import ProfiloUtente from "@/views/ProfiloUtente.vue";
import MainMenu from "@/components/MainMenu.vue";
import LoginAsUser from "@/views/LoginAsUser.vue";
import Debug from "@/views/Debug.vue";
import fornitoriRoutes from "@/router/fornitori";
import userRoutes from "@/router/admin";
import Support from "@/views/Support.vue";
import DownloadCenter from "@/views/DownloadCenter.vue";
import timesheetRoutes from "@/router/timesheet";
import configurazioneRoutes from "@/router/configurazione";


function addNextRoute(to: RouteLocationNormalized, from: RouteLocationNormalized, next:()=>void) {
    //@ts-ignore
    if(to.redirectedFrom && !to.redirectedFrom.meta?.public && to.redirectedFrom.fullPath){
        //@ts-ignore
        to.params['next_route'] = to.redirectedFrom.fullPath
        delete to.redirectedFrom
    }
    next();
}


const routes: Array<RouteRecordRaw> = [
    {
        path: '/debug',
        name: 'Debug',
        components: {
            default: Debug,
            nav: Menu
        },
        meta: {
            public: true
        },
    },
    {
        path: '/login',
        name: 'Login',
        components: {
            default: Login,
        },
        beforeEnter: [addNextRoute],
        props: true,
        meta: {
            public: true
        },
    },
    {
        path: '/loginasuser/',
        name: 'LoginAsUser',
        components: {
            default: LoginAsUser,
        },
        meta: {
            public: true
        },
    },
    {
        path: '/',
        name: 'Home',
        components: {
            default: Home,
            nav: MainMenu
        },
        props: {
            nav: {
                showHome: false
            }
        }
    },
    {
        path: '/profilo-utente/',
        name: 'ProfiloUtente',
        components: {
            default: ProfiloUtente,
            nav: MainMenu
        }
    },
    {
        path: '/support/',
        name: 'Support',
        components: {
            default: Support,
            nav: MainMenu
        }
    },
    {
        path: '/downloads/',
        name: 'DownloadCenter',
        components: {
            default: DownloadCenter,
            nav: MainMenu
        }
    },
    {
        path: '/404',
        name: 'NotFound',
        components: {
            default: NotFound,
            nav: Menu,
        },
    },
    {
        path: '/401',
        name: 'PermissionDenied',
        components: {
            default: PermissionDenied,
        },
    },
]

const router = createRouter({
    history: createWebHistory('/app/'),
    routes: routes.concat(authRoutes, projectRoutes, crmRoutes, fornitoriRoutes, userRoutes, timesheetRoutes, configurazioneRoutes),
})

export default router
